import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SideService {

  consumosNav = {
    label: 'Consumo', icon: 'show_chart', subItem: [
      { link: '/alertas', label: 'Mis alertas', icon: 'A' },
      { link: '/variables', label: 'Mis variables', icon: 'VAR' },
      { link: '/historial', label: 'Historial', icon: 'H' },
    ]
  };

  inmueblesNav = {
    label: 'Inmuebles', icon: 'account_balance', subItem: [
      // {link:'/mapa',label:'General',icon:'M'},
      // {link:'/mapa',label:'Cont. Arrendamiento',icon:'M'},
      // {link:'/mapa',label:'Cont. Mantenimiento',icon:'M'},
      // {link:'/mapa',label:'Facturas',icon:'M'},
      { link: '/graficas', label: 'Lecturas Contadores', icon: 'M' },
      { link: '/graficas_conjuntas', label: 'Comparar lecturas', icon: 'M' },
      // {link:'/mapa',label:'Rev. Mantenimiento',icon:'M'},
      { link: '/mapa', label: 'Búsqueda por Mapa', icon: 'BM' },
      { link: '/table', label: 'Base de datos', icon: 'DB' },
      { link: '/errors', label: 'Revisión', icon: 'Rev' },
    ]
  };

  everisNav = {
    label: 'Everis', icon: 'home', subItem: [
      { link: '/everis', label: 'Listado', icon: 'L' },
      { link: '/estadisticas_everis', label: 'Estadisticas', icon: '%' }
    ]
  };

  direccionNav = {
    label: 'Direccion', icon: 'home', subItem: [
      { link: '/direccion', label: 'Bingos Proveedor', icon: 'BxP' },
      { link: '/parking', label: 'Parking', icon: 'PK' },
      { link: '/pagos', label: 'Pagos Parking', icon: 'PP' }
    ]
  };

  public items = [
    /*{label:'Gestion',icon:'place',subItem:[
      {link:'/',label:'Gest .General',icon:'M'},
      {link:'/',label:'Gest .Cont. Arrendamiento',icon:'M'},
      {link:'/',label:'Gest .Cont. Mantenimiento',icon:'M'},
      {link:'/',label:'Gest .Facturas',icon:'M'},
      {link:'/',label:'Gest .Lecturas Contadores',icon:'M'},
      {link:'/',label:'Gest .Rev. Mantenimiento',icon:'M'},
      {link:'/',label:'Gest .Búsqueda por Mapa',icon:'M'},
      {link:'/',label:'Gest .Base de datos',icon:'DB'},
      {link:'/',label:'Gest .Revisión',icon:'Rev'},
    ]},*/

    /*{label:'Consumo',icon:'show_chart',subItem:[
      {link:'/alertas',label:'Mis alertas',icon:'A'},
      {link:'/variables',label:'Mis variables',icon:'Var'},
      {link:'/historial',label:'Historial',icon:'H'},
    ]},*/

    /*{link:'/bingo', label:'Bingos',icon:'account_balance'},
    {link:'/informes', label:'Informe',icon:'equalizer'},
    //{link:'/charts', label:'Charts',icon:'show_chart'},
    {link:'/',label:'Dashboard',icon:'dashboard'},
    {link:'/charts', label:'Charts',icon:'show_chart'},
    {link:'/maps', label:'Maps',icon:'place'},
    {link:'/mapa', label:'Mapa',icon:'place'},
    {link:'/table', label:'Base de datos',icon:'show_chart'},
    {link:'/errors', label:'Revisión',icon:'equalizer'} */
    // {link:'/editors', label:'Editors',icon:'edit'},

    // {link:'/calendar', label:'Calendar',icon:'date_range'}
  ];

  constructor() { }

  constructRol(){}

  getRolUser() {
    this.items.push(this.inmueblesNav);
  }

  getRolConsumos() {
    this.items.push(this.consumosNav);
    this.items.push(this.inmueblesNav);
  }

  getRolAdmin() {
    this.items.push(this.consumosNav);
    this.items.push(this.inmueblesNav);
    this.items.push(this.everisNav);
    this.items.push(this.direccionNav);
  }

  getRolEveris() {
    this.items.push(this.everisNav);
  }

  getRolDireccion() {
    this.items.push(this.direccionNav);
  }
}
